import { apiClient } from './client';
import type { VulnerabilityScanSummary } from '../types';

export const vulnScanApi = {
  async getSummary(): Promise<VulnerabilityScanSummary> {
    const { data } = await apiClient.get<VulnerabilityScanSummary>('/vuln-scan/summary');
    return data;
  },
  async runScan(): Promise<VulnerabilityScanSummary> {
    const { data } = await apiClient.post<VulnerabilityScanSummary>('/vuln-scan/run');
    return data;
  },
};
